export const SourceConstant = {
    lt:'<',
    gt: '>',
    slash: '/',
    quatationMakrs: '"',
    colon: ':',
    equals: '=',
    tags:{
        template: 'template',
        script: 'script',
        style: 'style'
    },
    param:{
        lang: 'lang="ts"'
    }
}
